import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getMeta } from "../seo";

const setTag = (selector, create, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!value) {
    el?.remove();
    return;
  }
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const metaEl = (key, name) => () => {
  const el = document.createElement("meta");
  el.setAttribute(key, name);
  return el;
};

export const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = getMeta(pathname);
    document.title = meta.title;
    setTag('meta[name="description"]', metaEl("name", "description"), "content", meta.description);
    setTag('meta[property="og:title"]', metaEl("property", "og:title"), "content", meta.title);
    setTag('meta[property="og:description"]', metaEl("property", "og:description"), "content", meta.description);
    setTag('meta[property="og:url"]', metaEl("property", "og:url"), "content", meta.canonical);
    setTag('meta[name="robots"]', metaEl("name", "robots"), "content", meta.noindex ? "noindex, follow" : null);
    setTag('link[rel="canonical"]', () => {
      const el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      return el;
    }, "href", meta.canonical);
  }, [pathname]);

  return null;
};
